module.exports = __webpack_public_path__ + "img/购买.c72685cf.png";